import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useSaveForum } from '@/api/information';
import InputFiles, { IPastData } from '@/components/common/Input/InputFiles/InputFiles';
import { useAuthStore } from '@/store/authStore';
import { useToastStore } from '@/store/toastStore';

import * as S from './style';

interface FormData {
	title: string;
	content: string;
}
interface FormErrors {
	title?: boolean;
	content?: boolean;
	[key: string]: boolean | undefined;
}

const Contact = () => {
	const params = useParams();
	const location = useLocation();
	const selectedStep = location.state?.step ?? '';
	const selectedData = location.state?.data ?? {};
	const userStore = useAuthStore();

	const [editPk, setEditPk] = useState('');
	const [formData, setFormData] = useState<FormData>({
		title: '',
		content: '',
	});
	const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
	const [pastFiles, setPastFiles] = useState<IPastData[]>([]);
	const [errors, setErrors] = useState<FormErrors>({});
	const [submitted, setSubmitted] = useState<boolean>(false);
	const [deletePk, setDeletePk] = useState<number[]>([]);

	const { openToast } = useToastStore();
	const navigate = useNavigate();

	const { mutateAsync: saveForum } = useSaveForum();

	const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
		const { name, value, type } = e.target;

		setFormData({ ...formData, [name]: value });

		if (submitted) {
			const newErrors = { ...errors };
			if (name === 'title' && value) delete newErrors.title;
			if (name === 'content' && value) delete newErrors.content;
			setErrors(newErrors);
		}
	};

	const validateForm = (): FormErrors => {
		const newErrors: FormErrors = {};

		if (!formData.title) newErrors.title = true;

		return newErrors;
	};

	const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const formErrors = validateForm();

		setErrors(formErrors);
		setSubmitted(true);

		const isValid = Object.keys(formErrors).length === 0;

		if (isValid) {
			const form = new FormData();
			if (selectedStep === '수정') form.append('forum_pk', selectedData.pk);
			form.append('member_pk', userStore.pk);
			form.append('forum_title', formData.title);
			form.append('forum_content', formData.content);
			uploadedFiles.forEach((file, index) => {
				form.append(`file[${index}]`, file);
			});
			form.append('delete_file_pks', deletePk.join(','));

			await saveForum(form);

			openToast({
				icon: 'alert',
				content: '등록되었습니다.',
				showTime: 3000,
			});

			setTimeout(() => {
				navigate('/information', { state: { menu: '자유게시판' } });
			}, 1000);

			setFormData({
				title: '',
				content: '',
			});
			setSubmitted(false);
		} else {
			console.log('폼 검증 실패');
		}
	};

	//파일 삭제
	const deletePastFileData = (pk: number) => {
		console.log(`pk : `, pk);
		setDeletePk([...deletePk, pk]);

		const tempPastList = pastFiles.filter((item) => item.filePk !== pk);
		setPastFiles([...tempPastList]);
	};

	useEffect(() => {
		if (selectedStep === '수정') {
			console.log(`selectedData: `, selectedData);
			setFormData({
				title: selectedData.title,
				content: selectedData.content,
			});
			setEditPk(selectedData.pk);
			const tempFileList = selectedData.files.map((item: any) => ({ fileName: item.file_original_name, fileSize: item.file_size, filePk: item.file_pk }));
			setPastFiles([...pastFiles, ...tempFileList]);
		}
	}, []);

	return (
		<main>
			<S.Container>
				<S.FormContainer>
					<S.Form onSubmit={handleSubmit} noValidate>
						<S.FormGroup>
							<S.Label htmlFor="title">
								제목<S.Required>*</S.Required>
							</S.Label>
							<S.Input
								type="text"
								id="title"
								name="title"
								placeholder="제목 입력"
								value={formData.title}
								onChange={handleChange}
								error={submitted && errors.title}
							/>
							{submitted && errors.name && <S.ErrorText>제목을 입력해 주세요.</S.ErrorText>}
						</S.FormGroup>

						<S.FormGroup>
							<S.Label htmlFor="content">
								내용<S.Required>*</S.Required>
							</S.Label>
							<S.Textarea id="content" name="content" placeholder="내용 입력" value={formData.content} onChange={handleChange} maxLength={2000} />
							{submitted && errors.content && <S.ErrorText>내용을 입력해 주세요.</S.ErrorText>}
						</S.FormGroup>

						<S.FormGroup>
							<S.Label htmlFor="files">첨부파일</S.Label>
							<InputFiles files={uploadedFiles} setFiles={setUploadedFiles} pastData={pastFiles} pastDataDeleteAction={deletePastFileData} />
						</S.FormGroup>

						<S.ButtonArea>
							<S.Button className="primary" type="submit" disabled={!formData.title || !formData.content}>
								{selectedStep === '수정' ? '수정' : '등록'}
							</S.Button>
						</S.ButtonArea>
					</S.Form>
				</S.FormContainer>
			</S.Container>
		</main>
	);
};

export default Contact;
